import { Container, Row, Col, Button } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import styled from "styled-components"

import Navigation from '../components/Layout/Navigation';
import Footer from '../components/Layout/Footer';
import { CTA } from '../components/Layout/CTA';

import '../components/GlobalStyle.css';

import ChannelSplash from '../assets/images/Channel Sales - Splash.png';
import Maximize from '../assets/images/Channel Sales - Maximize Returns.png';

import TrainingIcon from '../assets/icons/BPS Icon - Training.png';
import GraphIcon from '../assets/icons/BPS Icon - Graph.png';
import CustomIcon from '../assets/icons/BPS Icon - Custom.png';
import TargetIcon from '../assets/icons/BPS Icon - Target.png';
import StrengthenIcon from '../assets/icons/BPS Icon - Strengthen.png';

import { FadeLoad, FadeScroll, FadeLoadDelay } from '../components/styled/Motion.styled';
import { BPSCheckmarkList, Checkmark } from '../components/styled/Lists';
import { ChannelCards } from '../components/ChannelSalesComponents/ChannelCards';



const ChannelSales = () => {
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Programs | Channel Sales Incentives</title>
                <link rel="canonical" href="https://bestpayment.solutions/channel-sales" />
            </Helmet>
            <Navigation />
            <Container fluid className='circle-bg-2'>
                <Row className='pt-5 justify-content-evenly text-center'>
                    <Col lg={7}>
                        <FadeLoad>
                            <h2 className='fw-bold fs-24 color-sky-tint-1'>Channel Sales</h2>
                            <h1 className='fs-60'>
                                Driving excellence in channel sales incentive program management
                            </h1>
                        </FadeLoad>
                    </Col>
                </Row>
                <Row className='justify-content-center text-center'>
                    <Col lg={4} md={8}>
                        <FadeLoad>
                            <p>
                                Empower your partners to increase sales and sell your brand with <strong>Partner Up</strong>, our revolutionary Channel Sales Incentive System.
                            </p>
                        </FadeLoad>
                    </Col>
                </Row>
                <Row className='justify-content-center text-center'>
                    <Col sm={8}>
                        <FadeLoadDelay>
                            <img src={ChannelSplash} width='100%' />
                        </FadeLoadDelay>
                    </Col>
                </Row>
            </Container >
            <Container fluid className='text-center py-5 bg-cream'>
                <FadeScroll>
                    <Row className="justify-content-center align-items-center py-5">
                        <Col lg={6}>
                            <h3 className='fs-48'>Unlock success with "Partner Up" channel sales incentive platform</h3>
                            <p>
                                Supercharge your channel partnerships with the transformative power of incentive programs.
                            </p>
                        </Col>
                    </Row>
                </FadeScroll>
                <Row className="justify-content-evenly">
                    <Col xxl={3} xs={5} className='py-md-5'>
                        <img src={GraphIcon} width={60} />
                        <h4 className='fs-20 pt-4'>Increase sales performance</h4>
                        <p>
                            Incentive programs motivate channel partners to prioritize your products, causing sales to soar.
                        </p>
                    </Col>
                    <Col xxl={3} xs={6} className='py-md-5'>
                        <img src={CustomIcon} width={60} />
                        <h4 className='fs-20 pt-4'>Custom tailored solutions</h4>
                        <p>
                            Incentive programs can be easily tailored to fit different budgets, markets, or sales objectives.
                        </p>
                    </Col>
                    <Col xxl={3} xs={8} className='py-5'>
                        <img src={TargetIcon} width={60} />
                        <h4 className='fs-20 pt-4'>Short-term sales boosts</h4>
                        <p>
                            Incentive programs can provide a short-term boost in sales, perfect for end-of-quarter pushes, reducing excess inventory, or meeting year-end targets.
                        </p>
                    </Col>
                </Row>
                <Row className="justify-content-evenly">
                    <Col xxl={3} xs={6} className='py-md-5'>
                        <img src={TrainingIcon} width={60} />
                        <h4 className='fs-20 pt-4'>Improve product knowledge</h4>
                        <p>
                            Incentive programs can be used to educate partners on your product’s features and updates. This helps them sell more effectively.
                        </p>
                    </Col>
                    <Col xxl={3} xs={6} className='py-md-5'>
                        <img src={StrengthenIcon} width={60} />
                        <h4 className='fs-20 pt-4'>Strengthen channel relationships</h4>
                        <p>
                            Regular incentives and rewards acknowledge the efforts of channel partners. This cements and strengthens your partner relationships.
                        </p>
                    </Col>
                </Row>
            </Container>
            <Container fluid className='py-5'>
                <Row className="justify-content-evenly align-items-center text-center pt-5">
                    <Col lg={5}>
                        <h3 className='fs-48'>Maximize returns with expert program management</h3>
                        <p>
                            Invest in a channel sales program that is holistic, flexible, and results-driven.
                        </p>
                    </Col>
                </Row>
                <Row className="justify-content-evenly align-items-center py-3">
                    <Col md={5}>
                        <h5 className='fw-bold pt-4 fs-24'>Results you can rely on</h5>
                        <p>
                            Here is what you can expect with a Best Payment Solutions channel sales incentive program utilizing our “Partner Up” platform.
                        </p>
                        <BPSCheckmarkList>
                            <ul>
                                <li>
                                    <Checkmark />Increased overall sales
                                </li>
                                <li>
                                    <Checkmark />Enhanced brand awareness
                                </li>
                                <li>
                                    <Checkmark />Reversal of declining sales trends
                                </li>
                                <li>
                                    <Checkmark />Reduction in excess inventory
                                </li>
                                <li>
                                    <Checkmark />Increased specific SKU activity
                                </li>
                            </ul>
                        </BPSCheckmarkList>
                    </Col>
                    <Col md={6}>
                        <FadeScroll>
                            <img src={Maximize} width='100%' />
                        </FadeScroll>
                    </Col>
                </Row>
            </Container>
            <Container fluid className='py-5 circle-bg-2-scroll'>
                <Row className="justify-content-evenly align-items-center text-center pt-4">
                    <Col lg={5}>
                        <h3 className='fs-48'>What you get from working with Best Payment Solutions</h3>
                        <p>
                            At Best Payment Solutions, we offer comprehensive channel sales incentive programs, custom-tailored to boost your sales and enhance brand visibility.
                        </p>
                    </Col>
                </Row>
                <Row className='justify-content-center pb-5'>
                    <ChannelCards />
                </Row>
            </Container>
            <Container fluid className='bg-sky-tint-3 py-5'>
                <CTA />
            </Container>
            <Footer />
        </>
    );
}

export default ChannelSales;